import React, { useState, useRef } from 'react';
import useIntersectionObserver from '../hooks/useIntersectionObserver';
import useTypingEffect from '../hooks/useTypingEffect';

const ProgramInfo = () => {
    const [isVisible, setIsVisible] = useState(false);
    const ref = useIntersectionObserver(setIsVisible);
    const typingText = useTypingEffect("Bienvenidos a VML Academy", 20);
    const textRef = useRef(null);

    return (
        <div>
            <div id="acercade" ref={ref} className={`opacitycontainer container -mt-3 ${isVisible ? 'fade-in' : ''}`}>
                <h1 className="typing-text" ref={textRef}>{typingText}</h1>
                <h2 className="responsive-font mb-4">¡Conoce el Programa de Formación de VML! 🚀</h2>
                <p>¿Te apasiona la publicidad y el marketing? ¿Quieres aprender cómo funciona una agencia líder como VML y dar un salto en tu carrera profesional? Este programa es para ti.</p>
                <p>En VML creemos en compartir lo que sabemos hacer mejor, y por eso hemos creado un espacio donde podrás aprender directamente de los mejores profesionales de la industria. </p>
                <p><b>¿Cómo funciona?</b></p>
                <p>El programa incluye 5 cursos (cada uno con 2 o 3 sesiones) impartidos por expertos senior de nuestro equipo. Aprenderás con herramientas reales, casos de éxito y la visión estratégica que nos caracteriza como agencia. Además, tendrás la oportunidad de conectar con otras mentes inquietas que comparten tu pasión por la creatividad y la innovación.</p>
                <p>Lo mejor: ¡es completamente gratuito! 🎉</p>
                <p>Hay 20 cupos disponibles. Si completas más del 80% de las sesiones, recibirás una certificación oficial de VML que respaldará tu esfuerzo y aprendizaje.</p>
                <p><b>¿Quién puede participar?</b></p>
                <p>Este programa está abierto a estudiantes, recién egresados(as) o cualquier persona que quiera explorar y crecer en el mundo de la publicidad y el marketing.</p>
                <p><b>📅 Inscripciones abiertas hasta el 21 de julio.</b></p>
                <p>No te quedes fuera de esta experiencia única. ✨</p>
                <button className="boton btn btn-primary" onClick={() => document.getElementById('aplicar').scrollIntoView({ behavior: 'smooth' })}>POSTULA</button>
            </div>

            <div className='fechalugar container mt-3'>
                <div className='fechalugarleft col-md-6 zoom'>
                    <h3>Fechas:</h3>
                    <p>01 al 15 de agosto del 2025</p>
                </div>

                <div className='fechalugarright col-md-6 zoom'>
                    <h3>Lugar:</h3>
                    <p><strong>VML Perú</strong></p>
                    <p>Av. Alberto del Campo 411, Magdalena del Mar.</p>
                    <p>Piso 12 y 14</p>
                </div>
            </div>
        </div>
    );

};

export default ProgramInfo;
